import { LmText } from '@mes-ui/lemma';
import { Box, Stack, useMediaQuery } from '@mui/material';
import { WidgetOlympiadData } from 'api/types/widgets';
import { commonTheme } from 'portfolio3/styles/theme';

import { WIDGET_BLOCKS } from '../consts';

import './index.scss';

type OlympiadContentProps = {
  data: WidgetOlympiadData;
};

const OlympiadContent = ({ data }: OlympiadContentProps) => {
  const isMobile = useMediaQuery(commonTheme.breakpoints.down('commonSm'));
  const CONTENT_HEIGHT = isMobile ? 66 : 80;
  const Icon = WIDGET_BLOCKS.OLYMPIAD.icon;
  const subTitle = data.subjectName || data.name;
  const reward = data.reward || 'Участник';

  return (
    <Stack spacing={1.5} direction="row">
      <Box
        sx={{
          width: CONTENT_HEIGHT,
          height: CONTENT_HEIGHT,
          backgroundColor: WIDGET_BLOCKS.OLYMPIAD.iconBgColor,
          borderRadius: '22px',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon
          style={{
            width: 57.14,
            height: 57.14,
          }}
          fill={WIDGET_BLOCKS.OLYMPIAD.iconColor}
        />
      </Box>
      <Stack direction="column" spacing={0.5} style={{ minWidth: 0 }}>
        <LmText style={{ minWidth: 0 }} ellipsis variant="lg" weight="medium">
          {reward}
        </LmText>
        {subTitle && (
          <LmText className="olympiad-name" variant="lg">
            {subTitle}
          </LmText>
        )}
      </Stack>
    </Stack>
  );
};

export default OlympiadContent;
